var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgViberColor = function SvgViberColor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    x: 0.004,
    y: 0.064,
    fill: "#7360F2",
    rx: 8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#viber-color_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.143,
    height: 17.143,
    x: 1.433,
    y: 1.492,
    fill: "#7360F2",
    rx: 2.857
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#viber-color_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.737 4.707c-.86.012-2.709.153-3.741 1.101-.767.768-1.038 1.89-1.066 3.281s-.065 4 2.45 4.707v1.079s-.017.436.271.525c.347.108.551-.223.884-.581.182-.197.434-.484.624-.706 1.719.146 3.041-.185 3.192-.234.346-.112 2.31-.364 2.63-2.972.33-2.687-.16-4.388-1.044-5.154-.266-.246-1.342-1.027-3.74-1.037 0 0-.175-.011-.462-.008zm.026.756c.243-.002.393.007.393.007 2.027.01 2.998.62 3.224.824.747.64 1.129 2.173.85 4.419-.27 2.178-1.863 2.315-2.157 2.409-.125.04-1.286.329-2.747.234 0 0-1.087 1.312-1.427 1.653-.053.054-.116.075-.157.065-.058-.015-.074-.084-.074-.185l.01-1.794c-2.127-.59-2.003-2.809-1.978-3.97.024-1.163.242-2.116.89-2.757.876-.791 2.444-.9 3.175-.906zm.17 1.161a.136.136 0 0 0-.003.271c.726.005 1.316.24 1.799.71.479.468.723 1.103.729 1.936 0 .074.062.134.137.134a.136.136 0 0 0 .134-.136c-.007-.886-.276-1.605-.811-2.127-.531-.518-1.202-.782-1.986-.788m-1.769.31a.44.44 0 0 0-.275.053h-.004q-.289.167-.512.417l-.003.003a.84.84 0 0 0-.206.423.567.567 0 0 0 .026.241l.006.005c.06.214.211.57.538 1.162q.282.516.646.976.18.23.388.44l.059.059q.208.206.44.388.459.364.975.646c.593.327.95.478 1.163.538l.004.007a.6.6 0 0 0 .241.024.8.8 0 0 0 .423-.205l.004-.002a2.1 2.1 0 0 0 .415-.513l.001-.004c.1-.193.067-.376-.08-.5-.002 0-.312-.26-.463-.37a6 6 0 0 0-.497-.318c-.227-.127-.46-.047-.557.078l-.2.252c-.102.126-.293.11-.293.11-1.393-.356-1.765-1.766-1.765-1.766s-.017-.19.11-.293l.252-.2c.123-.096.203-.33.076-.557a6 6 0 0 0-.317-.498 13 13 0 0 0-.371-.462.37.37 0 0 0-.224-.133m2.005.393a.135.135 0 0 0-.008.27c.518.039.9.209 1.18.514.282.307.416.68.405 1.148a.136.136 0 0 0 .272.005c.012-.524-.149-.979-.476-1.336-.33-.362-.793-.56-1.361-.601zm.207.728a.136.136 0 0 0-.134.128.137.137 0 0 0 .128.143c.234.012.39.078.497.188s.173.277.186.52a.135.135 0 0 0 .27-.013c-.014-.288-.096-.526-.26-.695-.163-.17-.398-.257-.678-.271h-.01"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "viber-color_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1.433 1.492h17.143v17.143H1.433z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "viber-color_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.647 4.707h10.714V15.42H4.647z"
  })))));
};
export default SvgViberColor;